import { ethers } from 'ethers'
import { providers } from '@0xsequence/multicall'
import knownTokens from './known-tokens.json'

export function isWalletInstalled() {
  return typeof window !== 'undefined' && !!window.ethereum
}

export async function getCoinsFromLocalWallet() {
  if (!isWalletInstalled()) {
    return
  }

  const provider = new ethers.providers.Web3Provider(window.ethereum)
  await provider.send('eth_requestAccounts', [])
  const signer = provider.getSigner()
  const walletAddress = await signer.getAddress()

  const eth = await provider.getBalance(walletAddress)
  const balances = [{ symbol: 'ETH', balance: ethers.utils.formatEther(eth) }]

  const abi = ['function balanceOf(address owner) view returns (uint256)']
  const multicallProvider = new providers.MulticallProvider(provider)
  const multicallBalance = await Promise.all(
    knownTokens.map(
      token =>
        new Promise(async resolve => {
          try {
            const contract = new ethers.Contract(
              token.address,
              abi,
              multicallProvider
            )
            const balance = await contract.balanceOf(walletAddress)

            let formatted = ethers.utils.formatEther(balance)
            if (!!formatted && formatted.length > 20) {
              formatted = '0.0'
            }

            resolve({ symbol: token.symbol, balance: formatted })
          } catch (e) {
            resolve({ symbol: token.symbol })
          }
        })
    )
  )
  balances.push(...multicallBalance)

  return balances.filter(token => !!token.balance && token.balance !== '0.0')
}
